module.exports = __webpack_public_path__ + "images/bet_details_footer_logo.png";